import enLocale from 'element-ui/lib/locale/lang/zh-CN'
export default {
  languages: [{
    text: 'Chinese',
    val: 'zh'
  }, {
    text: 'English',
    val: 'en'
  }],
  international: {
    message: {
      title: 'IWOS 工程辅助系统',
      password: '密码',
      varificationCode: '验证码',
      userValidation: '请输入用户名称',
      mailValidation: '请输入正确的邮箱地址',
      passwordValidation: '请输入密码',
      codeValidation: '验证码错误',
      landing: '登录',
      add: "新增",
      delete: "删除",
      deleteSth: "删除{0}",
      authCode: "授权码",
      machineCode: "机器码",
      user: '用户',
      phone: '手机号',
      authType: '授权类型',
      status: '状态',
      expires: '有效期',
      createTime: '创建时间',
      updateTime: '更新时间',
      untreated: '未处理',
      treated: '已处理',
      cancel: '取消',
      determine: '确定',
      phoneApplication: '电话申请',
      appApplication: 'App申请',
      equipmentQuery: '设备查询',
      faultManage: '消缺管理',
      faultDevice: '故障站点',
      faultOrder: '消缺工单',
      userManage: '用户管理',
      engineerManage: '工程人员管理',
      customerManage: '客户管理',
      authManage: '授权管理',
      appAuth: 'APP授权',
      magickeyAuth: 'Magickey 授权',
      magickey: 'Magickey',
      enterMagickey: '请输入magickey',
      engineeringManage: '工程管理',
      documentManual: '文档手册',
      cancellation: '注销',
      exit: '确定退出此账户?',
      prompt: '提示',
      error: '用户或密码错误！',
      LoginFailed: '登录失败，请重新登录',
      timeRange: '选择时间范围',
      types: '全部类型',
      all: '全部',
      enterContent: '请输入内容',
      type: '类型',
      search: '搜索',
      serialNumber: '序列号',
      siteName: '安装位置',
      agent: '代理商',
      owner: '所属用户',
      Unassigned: '未指定工单',
      processing: '处理中',
      latestWeek: '最近一周',
      LastMonth: '最近一个月',
      LastMonths: '最近三个月',
      timeWrong: '查询时间有误，请选择正确的时间',
      deletePrompt: '此操作将永久删除该记录, 是否继续?',
      selectUser: '请选择要删除的用户',
      enterPhone: '请输入被授权人员手机号',
      validation: '验证',
      selectDate: '选择日期',
      failed: '失败',
      success: '成功',
      enterPhoneNumber: '请输入手机号',
      correctPhoneNumber: '请输入正确手机号',
      correctMachineCode: '请输入正确机器码',
      enterValidity: '请输入有效期',
      pleaseVerify: '请先验证',
      correctInformation: '请输入正确信息',
      editFailure: '编辑失败',
      correctEngineer: '请输入正确的工程人员',
      AuthSuccessful: '验证成功',
      newAuth: '新增授权',
      editAuth: '编辑授权',
      editDevice: '编辑设备',
      finalUser: '最终用户',
      modifyFailure: '修改失败',
      ModifySuccess: '修改成功',
      businessStatus: '选择业务状态',
      SdeviceType: '请选择设备类型',
      ScreateTime: '请选择创建时间',
      BindEquipment: '绑定设备故障',
      DeviceType: '设备类型',
      BusinessState: '业务状态',
      station: '变电站',
      line: '线路',
      siteName: '杆号',
      inventory: '库存',
      debugging: '调试',
      run: '运行',
      fault: '故障',
      maintenance: '维修',
      scrap: '报废',
      exception: '{0}故障类型',
      exceptionBall: '{0}球故障类型',
      Sdevice: '请选择设备',
      SdeviceIWOC: '请选择设备类型为IWOC的设备',
      none: '无',
      onlyDevice: '只能选择一台设备',
      DFaultType: '请选择设备故障类型',
      siteMissing: '此站点正在除缺，请前往消缺管理页面进行更新',
      FBindDevice: '绑定设备故障失败',
      SBindDevice: '绑定设备故障成功',
      device: '一台设备',
      order: '一项工单',
      leastOne: '请至少选择{0}!',
      repairOrder: '添至工单',
      bindingOrder: '绑定工单',
      sbindingOrder: '请选择绑定的工单',
      deleteOrder: '删除工单',
      orderNumber: '工单号',
      name: '工单名称',
      head: '负责人',
      Pselect: '请选择{0}',
      EquipmentList: '设备清单',
      detailed: '详细',
      noEquipment: '无设备',
      noAssigned: '未指派',
      orderMessage: '新建工单并添加设备至此工单',
      newWorkSheet: '请输入新工单名称',
      addMessage: '添加设备至已存在工单',
      removeEquipment: '删除设备',
      site: '站点',
      solution: '解决方案',
      time: '申报时间',
      phases: '{0}相',
      devicesCompleted: '只能删除状态已完成的设备',
      UnassignedMeg: '请选择{0}设备',
      newOrder: '新增工单失败',
      UnselectedOrder: '未选择工单',
      bindListFailed: '绑定工单失败',
      titleMeg1: '此工单包故障点列表',
      titleMeg2: '移除此工单故障点列表',
      ontEmpty: '{0} 不可为空',
      updateOrder: '更新工单 {0}',
      listError: '获取工程人员列表出错',
      nameS: '姓名',
      email: '邮箱',
      role: '角色',
      jurisdictions: '管辖区域',
      coding: '编码',
      nameOf: '名称',
      PuserRoles: '请选择用户角色',
      PcustomerType: '请选择客户类型',
      enterName: '请输入名称',
      entermailbox: '请输入正确邮箱',
      entercustomer: '请输入客户编号',
      newUsers: '新增用户',
      editCustomer: '编辑客户',
      newCustomer: '新增客户',
      userAdded: '用户添加成功',
      engineer: '工程人员',
      agentAdmin: '代理商管理员',
      serialNumber: '编号',
      DUserSuccess: '删除用户成功',
      DUserFailed: '删除用户失败',
      editUser: '编辑用户',
      PSbindAgent: '请选择绑定的代理商',
      allAgent: '全部代理商',
      BelongAgent: '所属代理商',
      updateInformation: '更新工程人员信息{0}',
      updateAgent: '更新代理商管理员{0}',
      RAgentFailed: '请求代理商失败，请重试',
      back: '返回',
      save: '保存',
      document: '文档{0}',
      package: '方案{0}',
      fault1: '故障{0}',
      describe: '描述',
      content: '内容',
      pleaseEnter: '请输入{0}',
      update: "更新",
      newbuild: '新建',
      fileFailed: '{0} 文件失败',
      fileSuccess: '{0} 文件成功',
      uploadFile: '上传文件',
      newDocument: '新建文档',
      newPlan: '新建方案',
      newFault: '新建故障',
      bindScheme: '绑定方案',
      creatDate: '创建日期',
      operation: '操作',
      view: '查看',
      edit: '编辑',
      downloadFile: '下载文件',
      unreadableFile: '此文件为不可读文件, 确定打开?',
      tagName: '标签名称',
      tagContains: '此标签包含文档，只能删除空标签',
      tagExists: '标签已经存在',
      tagError: '获取标签出错',
      dragFile: '将文件拖到此处，或',
      clickUpload: '点击上传',
      onlyUpload: '只能上传{0}文件',
      fileUploadf: '文件{0}上传失败',
      fileUploadS: '文件{0}上传成功',
      noStandFile: '没有符合标准的文件',
      deviceStatus: '查看设备状态',
      equipmentState: '设备状态',
      networkNumber: '网络号',
      stateName: '状态名称',
      stateValue: '状态值',
      s_dtutime_81C0: 'DTU时间',
      s_module_81BE: '模块',
      s_sn_81BF: '汇集单元序列号',
      s_dtu_version_81C1: 'DTU版本',
      s_imei: 'IMEI',
      s_imsi: 'IMSI',
      s_iccid: 'ICCID',
      s_cell_signal: '蜂窝网络信号值',
      s_cell_frequence: '频段',
      s_cell_mnc: 'MNC',
      s_cell_mcc: 'MCC',
      s_cell_lac: 'LAC',
      s_cell_reg_num: '注册状态',
      s_cell_cellid: 'CELL ID',
      s_reboot_code: '重启信息',
      s_ppp_auth_type: '认证方式',
      s_ppp_lcp_delay: 'LCP延时',
      s_ppp_connection: 'PPP连接',
      s_ppp_lose_rate: 'ppp 丢包率',
      s_net_ip: '网络层IP地址',
      s_net_received: '接收流量',
      s_net_send: '发送流量',
      s_net_ping_delay: 'Ping延时',
      s_app1_connection: '应用主站1是否连接',
      s_app2_connection: '应用主站2是否连接',
      s_gps_lock: 's_gps_lock',
      s_oc_baterry: '电池电压',
      s_oc_power_fetch: '太阳能取电电压',
      s_oc_cap_fetch: '电容电压',
      s_gps_geo: 'GPS 位置',
      s_om_online_A1: '第一组A相在线状态',
      s_om_online_B1: '第一组B相在线状态',
      s_om_online_C1: '第一组C相在线状态',
      s_om_online_A2: '第二组A相在线状态',
      s_om_online_B2: '第二组B相在线状态',
      s_om_online_C2: '第二组C相在线状态',
      s_om_online_A3: '第三组A相在线状态',
      s_om_online_B3: '第三组B相在线状态',
      s_om_online_C3: '第三组C相在线状态',


      longitude: '地理位置经度',
      latitude: '地理位置纬度',
      s_om_sn_A1: '第一组A相序列号',
      s_om_reserve_A1: '第一组A相预留',
      s_om_sversion_A1: '第一组A相软件版本号',
      s_om_hversion_A1: '第一组A相硬件版本号',
      s_om_vef_A1: '第一组A相电场',
      s_om_current_A1: '第一组A相电流',
      s_om_o_temperature_A1: '第一组A相外部传感器温度',
      s_om_baterry_A1: '第一组A相电池电压',
      s_om_power_fetch_A1: '第一组A相取电电压',
      s_om_condition_A1: '第一组A相线路状态',
      s_om_rssi_A1: '第一组A相信号强度',
      s_om_system_A1: '第一组A相系统状态',
      s_om_sleep_A1: '第一组A相休眠态',
      s_om_workmode_A1: '第一组A相工作模式',
      s_om_fault_stat_A1: '第一组A相故障状态',
      s_om_battery_stat_A1: '第一组A相电池状态',
      s_om_cap_1_A1: '第一组A相超级电容1',
      s_om_cap_2_A1: '第一组A相超级电容2',
      s_om_sn_B1: '第一组B相序列号',
      s_om_reserve_B1: '第一组B相预留',
      s_om_sversion_B1: '第一组B相软件版本号',
      s_om_hversion_B1: '第一组B相硬件版本号',
      s_om_vef_B1: '第一组B相电场',
      s_om_current_B1: '第一组B相电流',
      s_om_o_temperature_B1: '第一组B相外部传感器温度',
      s_om_baterry_B1: '第一组B相电池电压',
      s_om_power_fetch_B1: '第一组B相取电电压',
      s_om_condition_B1: '第一组B相线路状态',
      s_om_rssi_B1: '第一组B相信号强度',
      s_om_system_B1: '第一组B相系统状态',
      s_om_sleep_B1: '第一组B相休眠态',
      s_om_workmode_B1: '第一组B相工作模式',
      s_om_fault_stat_B1: '第一组B相故障状态',
      s_om_battery_stat_B1: '第一组B相电池状态',
      s_om_cap_1_B1: '第一组B相超级电容1',
      s_om_cap_2_B1: '第一组B相超级电容2',
      s_om_sn_C1: '第一组C相序列号',
      s_om_reserve_C1: '第一组C相预留',
      s_om_sversion_C1: '第一组C相软件版本号',
      s_om_hversion_C1: '第一组C相硬件版本号',
      s_om_vef_C1: '第一组C相电场',
      s_om_current_C1: '第一组C相电流',
      s_om_o_temperature_C1: '第一组C相外部传感器温度',
      s_om_baterry_C1: '第一组C相电池电压',
      s_om_power_fetch_C1: '第一组C相取电电压',
      s_om_condition_C1: '第一组C相线路状态',
      s_om_rssi_C1: '第一组C相信号强度',
      s_om_system_C1: '第一组C相系统状态',
      s_om_sleep_C1: '第一组C相休眠态',
      s_om_workmode_C1: '第一组C相工作模式',
      s_om_fault_stat_C1: '第一组C相故障状态',
      s_om_battery_stat_C1: '第一组C相电池状态',
      s_om_cap_1_C1: '第一组C相超级电容1',
      s_om_cap_2_C1: '第一组C相超级电容2',
      suffix: '单位',
      'conn_ok': '连接正常',
      'conn_no': '连接异常',
      'locked': '已锁定',
      'no_locked': '未锁定',
      "V": 'V',
      "A": 'A',
      'off_line': '离线',
      'online': '在线',
      'run_state': '运行态',
      'sleep_state': '休眠态',
      'unregistered': '未注册',
      'registered_native': '已注册(本地)',
      'registered': '已注册(漫游)',
      "hard_reboot": "硬重启",
      "soft_reboot": '软重启',
      "unable_analyze_device_state": '无法解析改设备状态',
      "have_no_state": "该设备没有状态值",
    },
  },
  ...enLocale
}



// WEBPACK FOOTER //
// ./src/international/zh.js